import ctl from '@netlify/classnames-template-literals';

export const buttonStyle = ctl(`
  flex
  relative
  cursor-pointer
`);
